export const META_TYPE = 'p1Meter';
export const META_VER = 'v1';

export const CMD_P1METER_REGISTRY_KEY = `${META_TYPE}:${META_VER}`;
